import { useEffect, useState } from 'react'
import { BsDot } from "react-icons/bs";
import { FiEdit2 } from "react-icons/fi";
import email from '../../assets/CandidateProfile/Container-Mail.svg'
import contact from '../../assets/CandidateProfile/Container-Phone.svg'
import address from '../../assets/CandidateProfile/Container-Location.svg'
import dob from '../../assets/CandidateProfile/Container-Calendar.svg'
import genders from '../../assets/CandidateProfile/Container-Gender.svg'
import marital from '../../assets/CandidateProfile/Container-Love.svg'
import disable from '../../assets/CandidateProfile/Container-Disability.svg'
import currencyIcon from '../../assets/CandidateProfile/Container_Rupees.svg'
import JobIcon from '../../assets/CandidateProfile/Container-job.svg'
import RelocationIcon from '../../assets/CandidateProfile/Container - Relocation.svg'
import LocationIcon from '../../assets/CandidateProfile/Container-Location.svg'
import CalendarIcon from '../../assets/CandidateProfile/Container-Calendar.svg'
import EducationIcon from '../../assets/CandidateProfile/Container-education.svg'
import { formatMonth, renderExpDuration } from '../../utils/Candidate Portal/ExperiencesList';
import { useLocation, useNavigate } from 'react-router-dom';

function Overview({ candidate, currentUser }) {

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const navigate = useNavigate()
    const location = useLocation()

    const { alternateEmailAddress, maritalStatus, alternatePhoneNumber, disability, permanentAddress, dateOfBirth, gender, preferredJob, preferredLocation, expectedCTC, noticePeriod, negotiableNoticePeriod, relocation, experiences, educations, primarySkills, skills, languages } = candidate

    const [allSkills, setAllSkills] = useState([])

    useEffect(() => {
        setAllSkills([])
        let tempArr = []
        if (primarySkills && Array.isArray(primarySkills) && primarySkills.length > 0) {
            const tempPrimarySkills = primarySkills.map(skill => ({ isPrimary: true, skill: skill.skill, experience: skill.experience || {} }))
            tempArr.push(...tempPrimarySkills)
        }
        if (skills && Array.isArray(skills) && skills.length > 0) {
            const tempSkills = skills.map(skill => ({ isPrimary: false, skill: skill.skill, experience: skill.experience || {} }))
            tempArr.push(...tempSkills)
        }
        if (tempArr.length > 0) {
            setAllSkills(tempArr)
        }
    }, [primarySkills, skills])


    function calculateAge(dateOfBirth) {
        if (!dateOfBirth) return null;

        const dob = new Date(dateOfBirth);
        const today = new Date();

        // Format properly (DD-MM-YYYY or your formatMonth logic)
        const birthDate = `${dob.getDate().toString().padStart(2, '0')}-${months[dob.getMonth()]}-${dob.getFullYear()}`;

        let age = today.getFullYear() - dob.getFullYear();

        // Adjust age if the birthday hasn't occurred yet this year
        const hasHadBirthdayThisYear =
            today.getMonth() > dob.getMonth() ||
            (today.getMonth() === dob.getMonth() && today.getDate() >= dob.getDate());

        if (!hasHadBirthdayThisYear) {
            age--;
        }

        return `${birthDate} (${age} years)`;
    }

    const formatAddress = (address) => {
        let formattedAddress = ''

        if (address && typeof address === 'object' && Object.entries(address).length > 0) {

            if (address.addressLine1) {
                formattedAddress += address.addressLine1
            }
            if (address.addressLine2) {
                formattedAddress += `, ${address.addressLine2}`
            }
            if (address.city) {
                formattedAddress += `, ${address.city}`
            }
            if (address.district) {
                formattedAddress += `, ${address.district}`
            }
            if (address.state) {
                formattedAddress += `, ${address.state}`
            }
            if (address.country) {
                formattedAddress += `, ${address.country}`
            }
            if (address.zipCode) {
                formattedAddress += ` - ${address.zipCode}`
            }

            return formattedAddress
        }
        else return null
    }

    const formatArray = (jobs) => {
        let formattedJobs = ''

        if (!jobs || !Array.isArray(jobs) || !jobs.length > 0) return null

        jobs.forEach((job, i) => {
            if (job) {
                if (i === 0) {
                    formattedJobs += job
                }
                else formattedJobs += `, ${job}`
            }
        })

        return formattedJobs
    }

    const formatRelocation = (value) => {
        if (value == null) return null
        return value ? 'Willing to relocate' : 'Not willing to relocate'
    }



    const jobPreferences = [
        {
            icon: JobIcon,
            title: 'Preferred Role(s)',
            value: formatArray(preferredJob) || '-'
        },
        {
            icon: LocationIcon,
            title: 'Preferred Location(s)',
            value: formatArray(preferredLocation) || '-'
        },
        {
            icon: currencyIcon,
            title: 'Expected CTC',
            value: expectedCTC?.amount || '-'
        },
        {
            icon: CalendarIcon,
            title: 'Notice Period',
            value: noticePeriod ? noticePeriod.toUpperCase() : '-'
        },
        {
            icon: CalendarIcon,
            title: 'Negotiable Notice Period',
            value: negotiableNoticePeriod ? negotiableNoticePeriod.toUpperCase() : '-'
        },
        {
            icon: RelocationIcon,
            title: 'Relocation',
            value: formatRelocation(relocation) || '-'
        }
    ]

    const personalInfo = [
        {
            icon: email,
            title: 'Alternate Email',
            value: alternateEmailAddress || '-',
            link: `mailto:${alternateEmailAddress}`
        },
        {
            icon: contact,
            title: 'Alternate Mobile Number',
            value: alternatePhoneNumber.number || '-',
            link: `tel:${alternatePhoneNumber.number}`
        },

        {
            icon: address,
            title: 'Permanent Address',
            value: formatAddress(permanentAddress) || '-',
        },
        {
            icon: dob,
            title: 'Date of Birth',
            value: calculateAge(dateOfBirth) || '-',
        },
        {
            icon: genders,
            title: 'Gender',
            value: gender ? gender.toUpperCase() : '-',
        },
        {
            icon: marital,
            title: 'Marital Status',
            value: maritalStatus || '-',
        },
        {
            icon: disable,
            title: 'Disability',
            value: disability?.isDisabled ? 'Yes' : 'No',
        },
        {
            icon: disable,
            title: 'Disability Description',
            value: disability?.desc || '-',
        }
    ]

    const formatNames = values => {
        if (values) {
            return values?.split(/[_-\s]/)?.map(v => v[0]?.toUpperCase() + v.slice(1)).join(' ');
        }
        else return " - "
    }

    return (
        <div>

            <div className='p-3 md:p-4 md:py-6 shadow-[0_0_8px_#e0e0e0] rounded-xl bg-white my-3'>
                <div className='flex justify-between gap-3'>
                    <div>
                        <h3 className='font-medium text-primary-300'>Personal Information</h3>
                        <p className='text-sm text-slate-600'>Personal details and contact Information</p>
                    </div>
                    {currentUser.role === 'job-seeker' && <FiEdit2 className="text-primary-500  font-bold" onClick={() => navigate(`/update-account/personalInformation?inverse=${true}&userId=${currentUser?._id}`, { state: { from: location.pathname } })} />}
                </div>
                <div className='flex flex-wrap gap-3  items-stretch'>
                    {
                        personalInfo.map((info, i) => {

                            return (
                                <div className={`flex gap-5 items-stretch rounded-lg bg-white p-2 md:p-4 min-w-full sm:min-w-52 sm:max-w-72 min-h-fit shadow flex-1 ${info.value === '-' && 'opacity-75'}`} key={i}>
                                    <img src={info.icon} className='my-1 text-slate-600 h-8 border rounded-full' alt={info.title} />
                                    <div className='text-[13px]'>
                                        <h4 className='h-fit text-slate-600'>{info.title}</h4>
                                        <p className='text-black font-medium mt-[2px]' onClick={() => info.link && window.open(info.link, '_blank')}>{info.value}</p>
                                    </div>
                                </div>
                            )

                        })
                    }
                </div>
            </div>

            <div className='p-3 md:p-4 md:py-6 shadow-[0_0_8px_#e0e0e0] rounded-xl bg-white my-3'>
                <div className='flex justify-between gap-3'>
                    <div>
                        <h3  className='font-medium text-primary-300'>Preferences</h3>
                        <p className='text-sm text-slate-600'>Preferences and Expectations</p>
                    </div>
                    {currentUser.role === 'job-seeker' && <FiEdit2 className="text-primary-500  font-bold" onClick={() => navigate(`/update-account/preferences?inverse=${true}&userId=${currentUser?._id}`, { state: { from: location.pathname } })} />}
                </div>
                <div className='flex flex-wrap gap-3 my-3'>
                    {
                        jobPreferences.map((info, i) => {

                            return (
                                <div className={`flex gap-5 items-start rounded-lg bg-white p-4 min-w-full sm:min-w-52 sm:max-w-72 shadow flex-1 ${info.value === '-' && 'opacity-75'}`} key={i}>
                                    <img src={info.icon} className='my-1 text-slate-600 h-8 border rounded-full' alt={info.title} />
                                    <div className='text-[13px]'>
                                        <h4 className='h-fit text-slate-600'>{formatNames(info.title)}</h4>
                                        <p className='text-black font-medium mt-[2px]' onClick={() => info.link && window.open(info.link, '_blank')}>{info.value}</p>
                                    </div>
                                </div>
                            )

                        })
                    }
                </div>
            </div>

            <div className='flex flex-wrap items-stretch md:flex-nowrap gap-3'>
                <div className='p-3 md:p-4 md:py-6 shadow-[0_0_8px_#e0e0e0] rounded-xl bg-white my-3 w-full md:w-6/12'>
                    <div className='flex justify-between gap-3'>
                        <div>
                            <h3  className='font-medium text-primary-300'>Education</h3>
                            <p className='text-sm text-slate-600'>Educational background</p>
                        </div>
                        {currentUser.role === 'job-seeker' && <FiEdit2 className="text-primary-500  font-bold" onClick={() => navigate(`/update-account/education?inverse=${true}&userId=${currentUser?._id}`, { state: { from: location.pathname } })} />}
                    </div>
                    <div className="flex flex-col gap-3 my-3">
                        {educations?.length > 0 ? (
                            educations.map((edu, i) => {
                                if (i < 2) {
                                    return (
                                        <div
                                            key={i}
                                            className="bg-white flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-5 px-3 sm:px-4 md:px-5 py-4 
                                  shadow rounded-lg"
                                        >
                                            {/* Left side */}
                                            <div className="flex flex-col sm:flex-row md:gap-4 gap-1 items-start">
                                                <img src={EducationIcon} className='my-1 text-slate-600 h-8 border rounded-full' alt={edu?.courseName || "education"} />
                                                <div className="flex flex-col">
                                                    {edu?.courseType && (
                                                        <p className="text-sm font-semibold text-black flex flex-wrap gap-1 items-center">
                                                            {`${formatNames(edu.courseType)} (${formatNames(edu?.courseCategory)}) ${edu?.courseName ? `${formatNames(edu?.courseName)}` : ""
                                                                }`}
                                                        </p>
                                                    )}

                                                    {edu?.institutionName && (
                                                        <p className="text-black font-normal text-sm  py-1">
                                                            {formatNames(edu?.institutionName)}, {edu?.state}
                                                        </p>
                                                    )}

                                                    <div className="text-gray-500 text-sm ">
                                                        {edu?.startDate && (
                                                            <span>
                                                                {new Date(edu?.startDate).toLocaleDateString("en-US", {
                                                                    year: "numeric",
                                                                })}
                                                            </span>
                                                        )}
                                                        {edu?.endDate ? (
                                                            <span>
                                                                {`${edu?.startDate ? " -" : ""} `}
                                                                {new Date(edu?.endDate).toLocaleDateString("en-US", {
                                                                    year: "numeric",
                                                                })}
                                                            </span>
                                                        ) : (
                                                            <span> - Present</span>
                                                        )}
                                                    </div>

                                                    {/* Mode + Grade */}
                                                    {edu?.mode && (
                                                        <div className="flex flex-wrap flex-row justify-start gap-3 text-sm mt-2">
                                                            <p className="text-primary-300 bg-blue-200 px-2 rounded-lg">
                                                                {formatNames(edu?.mode)}
                                                            </p>
                                                            <p className="text-primary-300 bg-blue-200 px-2 rounded-lg">
                                                                {edu?.grade?.type === "cgpa"
                                                                    ? `${edu?.grade?.value} cgpa`
                                                                    : `${edu?.grade?.value} %`}
                                                            </p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                return null
                            })
                        ) : (
                            <p className="text-center my-3">No Data Available!</p>
                        )}
                    </div>
                </div>

                <div className='p-3 md:p-4 md:py-6 shadow-[0_0_8px_#e0e0e0] rounded-xl bg-white my-3 w-full md:w-6/12'>
                    <div className='flex justify-between gap-3'>
                        <div>
                            <h3  className='font-medium text-primary-300'>Work Experience</h3>
                            <p className='text-sm text-slate-600'>Professional work history</p>
                        </div>
                        {currentUser.role === 'job-seeker' && <FiEdit2 className="text-primary-500  font-bold" onClick={() => navigate(`/update-account/experience?inverse=${true}&userId=${currentUser?._id}`, { state: { from: location.pathname } })} />}
                    </div>
                    <div className="flex flex-col gap-4 my-4">
                        {experiences?.length > 0 ? (
                            experiences?.map((exp, i) => {
                                // split description into bullet points
                                const points =
                                    exp?.description
                                        ?.split(".")
                                        .map((p) => p.trim())
                                        .filter((p) => p.length > 0) || [];

                                if (i < 2) {
                                    return (
                                        <div
                                            key={i}
                                            className="bg-white flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-5 px-2 md:px-4 py-2 md:py-4 shadow rounded-lg "
                                        >
                                            {/* Left side */}
                                            <div className="flex flex-col sm:flex-row md:gap-4 gap-2 items-start">
                                                <img src={JobIcon} className='my-1 text-slate-600 h-8 border rounded-full' alt={exp?.jobTitle || "experience"} />
                                                <div className="flex flex-col">
                                                    {exp?.jobTitle && (
                                                        <div className="text-sm font-semibold text-black flex flex-wrap gap-2 items-center">
                                                            <p className='text-sm'>{formatNames(exp.jobTitle)}</p>
                                                            <p className="text-primary-400 bg-blue-200 rounded-lg px-2 text-xs flex items-center gap-1 font-medoum">
                                                                {exp?.employmentType ? formatNames(exp?.employmentType) : exp?.employmentType} <BsDot />
                                                                {exp?.workMode ? formatNames(exp?.workMode) : ''}
                                                            </p>
                                                        </div>
                                                    )}

                                                    {exp?.employer && (
                                                        <p className="text-gray-700 font-medium text-sm">
                                                            {exp?.employer ? formatNames(exp?.employer) : exp?.employer},{exp?.city},{exp?.state}
                                                        </p>
                                                    )}

                                                    <div className="text-gray-500 text-sm">
                                                        {exp?.periodFrom && (
                                                            <span>
                                                                {formatMonth(
                                                                    new Date(exp.periodFrom).toLocaleDateString(), months
                                                                )}
                                                            </span>
                                                        )}
                                                        {exp?.periodTo ? (
                                                            <span>
                                                                {" "}
                                                                -{" "}
                                                                {formatMonth(
                                                                    new Date(exp.periodTo).toLocaleDateString(), months
                                                                )}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                {" "}
                                                                - {renderExpDuration(exp.periodFrom, exp.periodTo, exp.isOngoing)}
                                                            </span>
                                                        )}
                                                    </div>
                                                    {!exp.isOngoing && <span className="text-gray-500 text-sm sm:text-base">{renderExpDuration(exp.periodFrom, exp.periodTo, exp.isOngoing)}</span>}

                                                    {/* Bullet list */}
                                                    {points.length > 0 && (
                                                        <ul className="list-disc list-inside mt-2 space-y-1 text-gray-700 text-xs lg:text-sm">
                                                            {points.map((p, idx) => (
                                                                <li key={idx}>{p}</li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                }
                                return null
                            })
                        ) : (
                            <p className="text-center my-3">No Data Available!</p>
                        )}
                    </div>
                </div>
            </div>

            <div className='p-3 md:p-4 md:py-6 shadow-[0_0_8px_#e0e0e0] rounded-xl bg-white my-3'>
                <div className='flex justify-between gap-3'>
                    <div>
                        <h3  className='font-medium text-primary-300'>Skills</h3>
                        <p className='text-sm text-slate-600'>Professional skills and expertise</p>
                    </div>
                    {currentUser.role === 'job-seeker' && <FiEdit2 className="text-primary-500  font-bold" onClick={() => navigate(`/update-account/skills?inverse=${true}&userId=${currentUser?._id}`, { state: { from: location.pathname } })} />}
                </div>
                <div className='flex flex-wrap gap-3 my-3'>
                    {
                        allSkills.length > 0 ?
                        (allSkills.map((skill, i) => {
                            if (i < 10) {
                                return <span className={`px-4 py-1 rounded-lg bg-blue-50 text-primary-300 font-medium`} key={i}>{formatNames(skill.skill)} {(skill?.experience && Object.entries(skill?.experience).length > 0 && (skill?.experience?.year || skill?.experience?.month)) && ` (${skill.experience.year || 0}y ${skill.experience.month || 0}m)`}</span>
                            }
                            else return null
                        }))
                        :(
                            <div className={`flex gap-5 items-start justify-start rounded-lg bg-white p-4 shadow flex-1 `}>
                                <p className=''>No Data Available!</p>

                            </div>
                        )
                    }
                </div>
            </div>

            <div className='p-3 md:p-4 md:py-6 shadow-[0_0_8px_#e0e0e0] rounded-xl bg-white my-3'>
                <div className='flex justify-between gap-3'>
                    <div>
                        <h3  className='font-medium text-primary-300'>Language & Fluency</h3>
                        <p className='text-sm text-slate-600'>Communicatable languages</p>
                    </div>
                    {currentUser.role === 'job-seeker' && <FiEdit2 className="text-primary-500  font-bold" onClick={() => navigate(`/update-account/personalInformation?inverse=${true}&userId=${currentUser?._id}`, { state: { from: location.pathname } })} />}
                </div>
                <div className='flex flex-wrap gap-3 my-3'>

                    {
                        languages?.length > 0 ? (
                            <>
                                {
                                    languages?.map((lang, i) => {

                                        return (
                                            <div className={`flex gap-5 items-start justify-between rounded-lg bg-white p-4 min-w-64  shadow  `} key={i}>
                                                <div>
                                                    <h4 className='font-medium text-slate-600'>{formatNames(lang?.name)}</h4>
                                                    <div className="flex text-sm">
                                                        {(lang?.speak || lang?.read || lang?.write) ? (
                                                            <>
                                                                {lang?.read && (
                                                                    <div className="flex items-end">
                                                                        <p className="text-black font-normal">Read</p>
                                                                    </div>
                                                                )}

                                                                {lang?.speak && (
                                                                    <div className="flex items-end">
                                                                        {lang?.read && <BsDot className="text-xl" />}
                                                                        <p className="text-black font-normal">Speak</p>
                                                                    </div>
                                                                )}

                                                                {lang?.write && (
                                                                    <div className="flex items-end">
                                                                        {(lang?.speak || lang?.read) && <BsDot className="text-xl" />}
                                                                        <p className="text-black font-normal">Write</p>
                                                                    </div>
                                                                )}
                                                            </>
                                                        ) : (
                                                            '-'
                                                        )}
                                                    </div>

                                                </div>

                                                <div className='p-1'>
                                                    <p className={`px-3  rounded-md ${lang?.proficiency === 'native' ? 'bg-green-100 text-green-600' : 'bg-blue-100 text-primary-400'}`}>{formatNames(lang?.proficiency)}</p>
                                                </div>

                                            </div>
                                        )

                                    })
                                }
                            </>
                        ) : <>
                            <div className={`flex gap-5 items-start justify-start rounded-lg bg-white p-4 shadow flex-1 `}>
                                <p className=''>No Data Available!</p>

                            </div>
                        </>
                    }

                </div>
            </div>

        </div>
    )
}

export default Overview